var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-view-layout',{attrs:{"heading":_vm.heading,"desc":_vm.desc}},[_c('v-card',[_c('v-card-text',[_c('m-video-input',{on:{"loading":_vm.onLoading,"loaded":_vm.onLoaded}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }